export default __webpack_public_path__ + "static/media/example-content6.418c2751.jpg";